<template>
  <s-page>
    <s-header>
      <!-- style="text-shadow: 1px 8px 10px #aba8a8;"> -->
      <span class="-mb-6">R</span>
      <span class="-mb-6">e</span>
      <span class="-mb-6">p</span>
      <span class="-mb-6 tracking-tight">o</span>
      <span class="-mb-6 tracking-wide">r</span>
      <span class="-mb-6 tracking-wide">t</span>
      <span class="-mb-6">s</span>
    </s-header>
    <div class="mb-3 bg-gray-300 rounded-lg p-2">
      <div class="mb-2 relative flex justify-center">
        <div class="relative inline-block text-center">
          <h1
            class="text-2xl sm:text-3xl md:text-4xl leading-tight flex items-center justify-center font-normal"
          >
            <div class="flex items-center">
              <span>{{ selectedChart | capitalize }}</span>
              <button
                class="flex items-center ml-2"
                @click.stop="isDropdownOpen = !isDropdownOpen"
              >
                <unicon name="angle-down" class="w-8 h-8 fill-current z-30" />
              </button>
            </div>
          </h1>

          <!-- Dropdown Menu -->
          <div
            v-show="isDropdownOpen"
            class="absolute w-48 mt-2 transform bg-white rounded-lg shadow-lg py-2 z-50"
            v-click-outside="closeDropdown"
          >
            <div
              v-for="option in chartOptions"
              :key="option"
              class="px-6 py-2 hover:bg-gray-100 cursor-pointer text-center"
              :class="{ 'text-blue-500': selectedChart === option }"
              @click="selectChart(option)"
            >
              {{ option | capitalize }}
            </div>
          </div>
        </div>
      </div>

      <transition-expand mode="out-in">
        <div :key="selectedChart">
          <trend-chart-demo v-if="selectedChart === 'Weekly Trends'" />
          <store-metrics-chart v-if="selectedChart === 'Store Metrics'" />
          <!-- <chart-products v-if="selectedChart === 'products'" /> -->
        </div>
      </transition-expand>
    </div>

    <reports-invoices />
    <reports-inventory />
    <reports-prime-costs />
    <modal-product-prices />
  </s-page>
</template>

<script>
import ModalProductPrices from '@/components/ModalProductPrices.vue'
import ReportsPrimeCosts from '@/components/ReportsPrimeCosts.vue'
import ReportsInventory from '@/components/ReportsInventory.vue'
import ReportsInvoices from '@/components/ReportsInvoices.vue'
import TrendChartDemo from '@/components/TrendChartDemo.vue'
import StoreMetricsChart from '@/components/StoreMetricsChart.vue'
// import ChartProducts from '@/components/ChartProducts.vue'
import SHeader from '@/components/SHeader'
import SPage from '@/components/SPage'
import ModalSelection from '@/components/ModalSelection'
import TransitionExpand from '@/components/TransitionExpand'

export default {
  name: 'Reports',
  data() {
    return {
      selectedChart: 'Weekly Trends',
      chartOptions: ['Weekly Trends', 'Store Metrics'],
      isDropdownOpen: false
    }
  },
  components: {
    SHeader,
    SPage,
    ModalProductPrices,
    ReportsPrimeCosts,
    ReportsInventory,
    ReportsInvoices,
    TrendChartDemo,
    StoreMetricsChart,
    ModalSelection,
    TransitionExpand
    // ChartProducts
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event)
          }
        }
        document.addEventListener('click', el.clickOutsideEvent)
      },
      unbind(el) {
        document.removeEventListener('click', el.clickOutsideEvent)
      }
    }
  },
  methods: {
    selectChart(chart) {
      this.selectedChart = chart
      this.isDropdownOpen = false
    },
    closeDropdown() {
      this.isDropdownOpen = false
    }
  }
}
</script>

<style scoped>
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.2s;
}
.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease-out;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.expand-leave-from,
.expand-enter-to {
  opacity: 1;
  transform: translateY(0);
}
</style>
